import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsgService } from '../usg.service';
import { ExamsService } from '../exams.service';
import { AutotextService } from '../autotext.service';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-msk-soft-tissues',
    templateUrl: './msk-soft-tissues.component.html',
    styleUrls: ['./msk-soft-tissues.component.scss'],
    standalone: false
})
export class MskSoftTissuesComponent implements OnInit {
  editorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '5rem',
    maxHeight: 'auto',
    width: '100%',
    toolbar: [
      ['bold', 'italic', 'underline', 'strikeThrough'],
      ['paragraph', 'blockquote'],
      ['ordered', 'unordered']
    ]
  };

  // Exam-name options. Empty value = default (the exam type itself); the others are
  // stored in SubExamType and shown as-is in the header, printout and patient list.
  examTitleOptions = [
    { label: 'MSK & Soft Tissues', value: '' },
    { label: 'Musculoskeletal Ultrasound Summary', value: 'Musculoskeletal Ultrasound Summary' },
  ];

  constructor(
    public gs: UsgService,
    public es: ExamsService,
    public atS: AutotextService,
    public ls: LoginService,
    private fb: FormBuilder,
    private patService: PatientsService
  ) { }

  ngOnInit(): void {
  }

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.gs.gastroForm?.get('MedicalHistory');
          if (control) {
            const existing = (control.value || '').toString().trim();
            const previous = (res.previousSummary || '').toString().trim();
            // Replace only our own previously-pasted AI block (exact match), so a
            // doctor's hand-typed notes are never overwritten; otherwise append.
            if (previous && existing === previous) {
              control.setValue(res.summary);
            } else {
              control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
            }
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

  // Currently selected exam-name option (reflects the persisted SubExamType).
  get selectedTitle(): string {
    return this.es.subExamType || '';
  }

  // Persist the chosen exam name on the exam (SubExamType) — consistent with endoscopy.
  setExamTitle(value: string): void {
    this.es.subExamType = value;
    this.es.saveVals('SubExamType', value, false, 'exams');
  }
}
